import { assetDictionary } from "@dinahmoe/dmafjs-assetloader";
import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";


class SvgHtml extends VisualSuperHtml {
  handlers = this.extendParentHandlers({
    "source.imageId": this.setImageId,
    "source.fill": this.setFill,
    "source.stroke": this.setStroke
  });

  setFill(node) {
    if (node.props["source.fill"]) {
      node.element.style.fill = node.props["source.fill"];
    }
  }

  setStroke(node) {
    if (node.props["source.stroke"]) {
      node.element.style.stroke = node.props["source.stroke"];
    }
  }

  setProps(node) {
    let svgHtmlElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    const imageId = node.props["source.imageId"];
    svgHtmlElement = assetDictionary.get(`assets.data.${imageId}`) || svgHtmlElement;

    if (imageId) {
      try {
        assetDictionary.set(`assets.data.${imageId}`, svgHtmlElement.cloneNode(true));
      } catch (error) {
        console.warn(error, svgHtmlElement, node.props["source.imageId"]);
        svgHtmlElement.style.visibility = "hidden";
      }
    } else {
      svgHtmlElement.style.visibility = "hidden";
    }

    node.element = create(node, svgHtmlElement);
    this.updateImageVisibility(node);

    // TODO: temp fix - ensure element has style object before framework sets properties
    if (node.element && !node.element.style) {
      const newSvgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      node.element.parentNode?.replaceChild(newSvgElement, node.element);
      node.element = newSvgElement;
    }

    super.setProps(node);
    this.setFill(node);
    this.setStroke(node);
  }

  setImageId(node) {
    const imageId = node.props["source.imageId"];
    const svgHtmlElement = assetDictionary.get(`assets.data.${imageId}`);

    if (svgHtmlElement) {
      node.element.innerHTML = svgHtmlElement.innerHTML;

      try {
        const { x, y, width, height } = svgHtmlElement.viewBox.baseVal;
        node.element.setAttribute("viewBox", `${x} ${y} ${width} ${height}`);
        node.element.style.visibility = "visible";
      } catch (error) {
        // TODO: temp fix - handle malformed SVG viewBox
        node.element.style.visibility = "hidden";
      }

      this.setFill(node);
      this.setStroke(node);
    } else {
      node.element.style.visibility = "hidden";
    }
  }

  updateImageVisibility(node) {
    node.element.addEventListener("load", () => (node.element.style.visibility = "visible"));
    node.element.addEventListener("error", () => (node.element.style.visibility = "hidden"));
  }
}

const svgHtml = new SvgHtml("visual:svg");
visualEntities.set("visual:svg", svgHtml);
export { SvgHtml, svgHtml };
